import { isNumber } from 'lodash-es';

import { IOffer } from '@rbi-ctg/menu';
import { CustomEventNames, EventTypes, IMParticleCtx } from 'state/mParticle';
import { getFirstStringInLocaleBlockContent } from 'utils/sanity';

export const logOfferClick = (
  offer: IOffer,
  offerIndex: number | undefined | null,
  offersDisplayed: number | undefined | null,
  ctx: IMParticleCtx
) => {
  ctx.logEvent(CustomEventNames.OFFER_CLICK, EventTypes.UserContent, {
    'Offer Name': offer.name ? getFirstStringInLocaleBlockContent(offer.name) : '',
    'Short Code': offer.shortCode,
    'Sanity ID': offer._id,
    'Offer Position': isNumber(offerIndex) ? offerIndex + 1 : undefined,
    'Offer Display Count': offersDisplayed,
    'UI Pattern': offer.uiPattern,
  });

  ctx.logRBIEvent({
    name: CustomEventNames.OFFER_SELECTED,
    type: EventTypes.Other,
    attributes: {
      engineId: '',
      sanityId: offer._id,
      name: offer.name ? getFirstStringInLocaleBlockContent(offer.name) : '',
    },
  });
};
